var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Delete',{attrs:{"resource":"sources","dispatch":"projectMeteringStore/sourceStore/delete","routing":"sources","id":_vm.id,"params":{ project_id: _vm.$route.params.project_id },"disabled":_vm.disabled}})}
var staticRenderFns = []

export { render, staticRenderFns }